import GettingStarted from "components/GettingStarted";
import TranscriptSingle from "components/TranscriptSingle";
import Conversation from "components/Conversation";

import "./styles.scss";

function TranscriptionDisplay({ conversation, currentMessage, conversationMode, hideGettingStarted, listeningStatus }) {
    if (!hideGettingStarted) {
        return <GettingStarted />;
    }

    if (!conversationMode) {
        return (
            <TranscriptSingle conversation={conversation} currentMessage={currentMessage} listeningStatus={listeningStatus} />
        );
    } else {
        return (
            <Conversation conversation={conversation} currentMessage={currentMessage} />
        );
    }
}

export default TranscriptionDisplay;
